// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getPrimaryProductStatuses} from '../../shared/repositories';

export const fetchPrimaryProductStatuses = () =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return getPrimaryProductStatuses()
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.READ_PRIMARY_PRODUCT_STATUSES_SUCCESS
                });

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/primary-product-statuses.js